var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96376 3.41495C9.38277 3.41495 9.72244 3.07527 9.72244 2.65626C9.72244 2.23726 9.38277 1.89758 8.96376 1.89758C8.54475 1.89758 8.20508 2.23726 8.20508 2.65626C8.20508 3.07527 8.54475 3.41495 8.96376 3.41495Z",
    stroke: "#1D2739",
    strokeWidth: 1.51736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96376 8.97867C9.38277 8.97867 9.72244 8.63899 9.72244 8.21999C9.72244 7.80098 9.38277 7.4613 8.96376 7.4613C8.54475 7.4613 8.20508 7.80098 8.20508 8.21999C8.20508 8.63899 8.54475 8.97867 8.96376 8.97867Z",
    stroke: "#1D2739",
    strokeWidth: 1.51736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96376 14.5423C9.38277 14.5423 9.72244 14.2026 9.72244 13.7836C9.72244 13.3646 9.38277 13.0249 8.96376 13.0249C8.54475 13.0249 8.20508 13.3646 8.20508 13.7836C8.20508 14.2026 8.54475 14.5423 8.96376 14.5423Z",
    stroke: "#1D2739",
    strokeWidth: 1.51736,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotsIcon);
export default __webpack_public_path__ + "static/media/verticalDotsIcon.b938a0db64411e16130b12e57cf7efa4.svg";
export { ForwardRef as ReactComponent };